module.exports = __webpack_public_path__ + "img/hero1.cdbe8be3.jpg";